// App.js
import React, { useEffect } from 'react';
import Header from './components/Header';
import Home from './components/home';
import Footer from './components/Footer';
import { Routes, Route, useLocation } from "react-router-dom";
import BakeryOutletPage from './components/bakeryOutlet';
import CoffeeOutletPage from './components/COffeeOutlet';
import IceCreamOutletPage from './components/IceCreamOutlet';
import RestaurantOutletPage from './components/RestarantOutlet';
import CloudKitchenOutletPage from './components/CloudKitchenOutlet';
import FoodCourtOutletPage from './components/FoodCourtOutlet';
import './App.css';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bakeryfeature" element={<BakeryOutletPage />} />
          <Route path="/coffeefeature" element={<CoffeeOutletPage />} />
          <Route path="/icecreamfeature" element={<IceCreamOutletPage />} />
          <Route path="/restaurantfeature" element={<RestaurantOutletPage />} />
          <Route path="/cloudkitchenfeature" element={<CloudKitchenOutletPage />} />
          <Route path="/foodcourtfeature" element={<FoodCourtOutletPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
